import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";

const NotFoundContainer = ({ translate }) => <h1>404</h1>;

NotFoundContainer.propTypes = {
  translate: PropTypes.func
};

const mapStateToProps = ({ common, locale }) => ({
  translate: getTranslate(locale)
});

const mapDispatchToProps = null;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotFoundContainer);



// WEBPACK FOOTER //
// ./src/routes/404/containers/NotFoundContainer.js